import { Body, Close, Description, Footer, Header, Root, Title } from "./bottom-sheet";

export const BottomSheet = {
  Root,
  Header,
  Title,
  Description,
  Body,
  Footer,
  Close,
};

export type {
  BottomSheetDetent,
  BottomSheetDetents,
  BottomSheetRootProps,
  BottomSheetHeaderAlign,
  BottomSheetHeaderProps,
  BottomSheetTitleProps,
  BottomSheetDescriptionProps,
  BottomSheetBodyProps,
  BottomSheetFooterLayout,
  BottomSheetFooterProps,
  BottomSheetCloseProps,
} from "./types";
